"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOnsiteMessageEventPropTypes = exports.onsiteMessageEventPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onsiteMessageEventPropTypes = {
  eventData: _propTypes.default.object,
  newLaneEventData: _propTypes.default.object,
  additionalClickStreamData: _propTypes.default.object,
  gaEventData: _propTypes.default.shape({
    action: _propTypes.default.string,
    label: _propTypes.default.string,
    category: _propTypes.default.string
  }),
  signalForTriggerTracking: _propTypes.default.bool
};
exports.onsiteMessageEventPropTypes = onsiteMessageEventPropTypes;
var defaultOnsiteMessageEventPropTypes = {
  eventData: {},
  newLaneEventData: {},
  additionalClickStreamData: {},
  gaEventData: {},
  signalForTriggerTracking: true
};
exports.defaultOnsiteMessageEventPropTypes = defaultOnsiteMessageEventPropTypes;